import React from "react";
import point from "./../../../../../Images/point.png";

const BodyWaxingRightWhat = () => {
  return (
    <div className="blogWhat-content">
      <h5>What Is Body Waxing?</h5>
      <p>
        {" "}
        Body waxing is a hair removal technique that involves applying warm wax
        to the skin and quickly removing it, pulling hair out from the root.
        This method can be used on virtually any part of the body, including
        <a href="https://scentlifestyle.com/legs-waxing-detan-threading-salon-in-bangalore">
          legs
        </a>
        ,{" "}
        <a href="https://scentlifestyle.com/arms-waxing-detan-threading-salon-in-bangalore">
          arms
        </a>
        , underarms, chest,{" "}
        <a href="https://scentlifestyle.com/body-back-waxing-detan-threading-salon-in-bangalore">
          back
        </a>
        , bikini area, and even the face.
      </p>
      <p>There are two primary types of wax used in salons:</p>
      <ul>
        <li>
          <span>
            <img src={point} alt="checked" />
            Soft wax (strip wax):
          </span>
          <p>Applied thinly and removed using cloth or paper strips.</p>
        </li>
        <li>
          <span>
            <img src={point} alt="checked" />
            Hard wax:
          </span>
          <p>Applied thickly, allowed to cool, and removed without strips. </p>
        </li>
      </ul>
      <p>
        Each type has its own advantages and may be chosen depending on your
        skin type, hair thickness, and area of the body being waxed.
      </p>
    </div>
  );
};

export default BodyWaxingRightWhat;
